import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FeatherTruck } from '@subframe/core';
import { SanitizedHtml } from '@/shared/components/ui/common/SanitizedHtml';
import type { CartaCitacaoCertificado } from '../../../types/certificadoAcessosTypes';
interface SecaoCartaCitacaoProps {
  cartaCitacao: CartaCitacaoCertificado;
}
export function SecaoCartaCitacao(t0) {
  const $ = _c(48);
  const {
    cartaCitacao
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-brand-600 mb-[10px] flex items-center gap-[10px]"><FeatherTruck className="h-[15px] w-[15px]" /><span className="text-[13px] font-semibold">Correios (AR)</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== cartaCitacao.requerido) {
    t2 = <span className="border-brand-600 text-brand-600 mb-[14px] inline-block rounded-[5px] border border-solid px-3 py-[5px] text-[12px] font-semibold">Carta de Citação — {cartaCitacao.requerido}</span>;
    $[1] = cartaCitacao.requerido;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-[14px] h-px bg-neutral-900 opacity-85" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== cartaCitacao.entregaLabel || $[6] !== cartaCitacao.postagemLabel) {
    t5 = <div className="mb-[18px] text-[13.5px] leading-[2] font-bold text-neutral-700">{cartaCitacao.postagemLabel}{t4}{cartaCitacao.entregaLabel}</div>;
    $[5] = cartaCitacao.entregaLabel;
    $[6] = cartaCitacao.postagemLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <strong className="text-brand-600">Requerente:</strong>;
    t7 = <br />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    t9 = <br />;
    t10 = <strong className="text-brand-600">Número do processo</strong>;
    t11 = <br />;
    $[10] = t10;
    $[11] = t11;
    $[12] = t8;
    $[13] = t9;
  } else {
    t10 = $[10];
    t11 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t12;
  if ($[14] !== cartaCitacao.numeroProcesso || $[15] !== cartaCitacao.requerente) {
    t12 = <div>{t6}{t7}{cartaCitacao.requerente}{t8}{t9}{t10}{t11}{cartaCitacao.numeroProcesso}</div>;
    $[14] = cartaCitacao.numeroProcesso;
    $[15] = cartaCitacao.requerente;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <strong className="text-brand-600">Requerido:</strong>;
    t14 = <br />;
    $[17] = t13;
    $[18] = t14;
  } else {
    t13 = $[17];
    t14 = $[18];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <br />;
    t16 = <br />;
    t17 = <strong className="text-brand-600">Rito</strong>;
    t18 = <br />;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t15 = $[19];
    t16 = $[20];
    t17 = $[21];
    t18 = $[22];
  }
  let t19;
  if ($[23] !== cartaCitacao.requerido || $[24] !== cartaCitacao.rito) {
    t19 = <div>{t13}{t14}{cartaCitacao.requerido}{t15}{t16}{t17}{t18}{cartaCitacao.rito}</div>;
    $[23] = cartaCitacao.requerido;
    $[24] = cartaCitacao.rito;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t12 || $[27] !== t19) {
    t20 = <div className="flex gap-[60px] text-[12.5px] leading-[1.7] text-neutral-700">{t12}{t19}</div>;
    $[26] = t12;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Image src="/Logo.svg" alt="Arbitralis" width={85} height={20} className="mt-1 h-5 w-auto" />;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== t20) {
    t22 = <div className="flex items-start justify-between">{t20}{t21}</div>;
    $[30] = t20;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  let t24;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <strong className="text-brand-600">Endereço de entrega:</strong>;
    t24 = <br />;
    $[32] = t23;
    $[33] = t24;
  } else {
    t23 = $[32];
    t24 = $[33];
  }
  let t25;
  if ($[34] !== cartaCitacao.enderecoEntrega) {
    t25 = <div className="mt-3 border-t border-solid border-neutral-200 pt-3 text-[12.5px] leading-[1.7] text-neutral-700">{t23}{t24}{cartaCitacao.enderecoEntrega}</div>;
    $[34] = cartaCitacao.enderecoEntrega;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] !== t22 || $[37] !== t25) {
    t26 = <div className="bg-neutral-100 px-[26px] py-[22px]">{t22}{t25}</div>;
    $[36] = t22;
    $[37] = t25;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] !== cartaCitacao.conteudoHtml) {
    t27 = <SanitizedHtml html={cartaCitacao.conteudoHtml} perfil="restrito" className="px-[26px] pt-[22px] pb-[26px] text-[12px] leading-[1.85] text-neutral-700 [&_h1]:mb-[18px] [&_h1]:text-center [&_h1]:text-[15px] [&_h1]:font-bold [&_h1]:tracking-[1px] [&_h1]:text-neutral-900 [&_p]:mb-[14px] [&_strong]:text-neutral-900" />;
    $[39] = cartaCitacao.conteudoHtml;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  let t28;
  if ($[41] !== t26 || $[42] !== t27) {
    t28 = <div className="overflow-hidden rounded-[12px] border border-solid border-neutral-900/20">{t26}{t27}</div>;
    $[41] = t26;
    $[42] = t27;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] !== t2 || $[45] !== t28 || $[46] !== t5) {
    t29 = <div className="px-[37px] pb-6">{t1}{t2}{t3}{t5}{t28}</div>;
    $[44] = t2;
    $[45] = t28;
    $[46] = t5;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  return t29;
}